/**
 * Inline SVG marks for the tracking-insight sections.
 *
 * Deliberately not `public/images/icons/*.svg` imports: those resolve through @svgr/webpack in
 * the Next build but come back as asset URLs under Vitest (`assetsInclude`), so a component
 * rendering one is unmountable in tests. One small path inline avoids that split entirely.
 */

export const ChevronDownIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    width='16'
    height='16'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden='true'
    focusable='false'
  >
    <polyline points='6 9 12 15 18 9' />
  </svg>
);

/** Material `arrow_forward`; the back arrow is the same path mirrored. */
const ARROW_PATH = 'M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z';

export const ArrowIcon: React.FC<{ direction: 'left' | 'right'; className?: string }> = ({ direction, className }) => (
  <svg
    className={className}
    width='20'
    height='20'
    viewBox='0 0 24 24'
    fill='currentColor'
    aria-hidden='true'
    focusable='false'
    style={direction === 'left' ? { transform: 'scaleX(-1)' } : undefined}
  >
    <path d={ARROW_PATH} />
  </svg>
);
